import React from 'react';
import DynamicCard from '../DynamicCard';
import JetHero from './Jet-Hero-Fixed.png';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { useMediaQueries } from '../../hooks/useMediaQueries';

const useStyles = makeStyles({
    flexBox: {
        margin: '0em 0em 5em 0em',
    },
    typography: {
        paddingRight: '3em',
        height: '100%',
    },
    mobileTypography: {
        marginTop: '1em',
        height: '100%',
    },
    heroImage: {
        marginTop: '-3em',
    },
    mobileHeroImage: {
        maxHeight: '300px',
    },
    card: {
        marginRight: '1em',
    },
    fullWidthCard: {
        width: '100%',
        marginBottom: '1em',
    },
});

// Landing page card content
const cardInformation = {
    jetOverview: {
        title: 'Overview',
        path: '/jet/general/overview',
        content:
            'Learn more about Signiant Jet, including general concepts, deployment strategies, and a high-level \
                    overview of how it can integrate with other Signiant products.',
    },
    jetSystemRequirements: {
        title: 'System Requirements',
        path: '/jet/general/system-requirements',
        content:
            'View the system requirements for the Signiant SDCX Server, which includes the infrastructure\
                    required to transfer files using Signiant Jet.',
    },
};

export default () => {
    const classes = useStyles();
    const isMediumDisplay = useMediaQueries('md');
    return (
        <>
            <Box
                className={classes.flexBox}
                display="flex"
                flexDirection={!isMediumDisplay ? 'row' : 'column-reverse'}
                alignItems="flex-start"
            >
                <Box flexBasis="60%" className={!isMediumDisplay ? classes.typography : classes.mobileTypography}>
                    <Typography variant="p">
                        Signiant Jet is a SaaS solution that helps you transfer content within or between organizations
                        using on-premises and cloud-based servers. Jet provides the flexibility, reliability and
                        security that are essential for today's global media workflows.
                    </Typography>
                </Box>
                <Box flexBasis="40%" display="flex" justifyContent="flex-end" flexDirection="row">
                    <img
                        className={!isMediumDisplay ? classes.heroImage : classes.mobileHeroImage}
                        src={JetHero}
                        alt="Jet Hero"
                    />
                </Box>
            </Box>
            <Box display="flex" flexDirection={!isMediumDisplay ? 'row' : 'column'} alignItems="flex-start">
                <Box flexBasis="50%" className={!isMediumDisplay ? classes.card : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.jetOverview} />
                </Box>
                <Box flexBasis="50%" className={!isMediumDisplay ? null : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.jetSystemRequirements} />
                </Box>
            </Box>
        </>
    );
};
